<template>
  <div style="background: #fff" class="login">
    <!-- <div style="background-image: url('/static/images/login-bg1.png'); background-size: 100% 100%;margin-bottom: 40px" class="login-box">
      <router-link to="/">
      </router-link>
    </div> -->
    <img style="width:100%;margin-bottom: 16px;" src="/static/images/login-bg3.png" />
    <van-cell-group >
      <!-- <div class="van-cell van-hairline van-field van-field--has-icon">
        <i class="van-icon iconfont gonghao icon-gonghao  inputlabel"></i>
        <div class="van-cell__value">
          <input type="text" placeholder="请输入工号" v-model="account" class="van-field__control">
        </div>
      </div>
      <div class="van-cell van-hairline van-field van-field--has-icon">
        <i class="van-icon iconfont shenfenzheng icon-shenfenzheng  inputlabel"></i>
        <div class="van-cell__value">
          <input type="text" placeholder="请输入身份证" v-model="password" class="van-field__control">
        </div>
      </div> -->
      <div class="van-cell van-hairline van-field van-field--has-icon">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-shoujihao"></i><span>手机号</span></div>-->
        <i class="van-icon iconfont gonghao icon-gonghao  inputlabel"></i>
        <div class="van-cell__value">
          <input type="text" placeholder="请输入工号" v-model="work_number" class="van-field__control">
        </div>
      </div>
      <div class="sendCode" style="overflow: hidden">
        <div style="padding: 4px 15px 5px 15px" class="codebox van-cell van-hairline van-field van-field--has-icon">
          <!--<div class="van-cell__title"><i class="van-icon iconfont icon-yanzhengma"></i><span>验证码</span></div>-->
          <i class="van-icon iconfont mima icon-mima  inputlabel" style="margin-top: 8px"></i>
          <div class="van-cell__value"><input type="password" placeholder="初始密码为职工工号+八位数出生年月" v-model="password" class="van-field__control"></div>
        </div>
        <!-- <div  class="van-field__button">
          <van-button slot="button" size="small" @click="getCode()" class="theme-bg gecode" :loading="codeLoading">获取验证码</van-button>
        </div> -->
      </div>
      <van-cell class="restBox">
        <router-link to="/backpass">忘记密码？</router-link>
        <!--<router-link to="/register" class="theme-col float-right">立即注册</router-link>-->
      </van-cell>
      <!--<van-cell>-->
        <van-button size="large" class="theme-bg loginbtn" @click="senData()" :loading="loading">登录</van-button>
        <router-link to="/notelogin" tag="div" class="theme-col text-cent">短信验证码登录</router-link>
        <!--<router-link to="/register" tag="div" class="theme-col text-cent">立即注册</router-link>-->
      <!--</van-cell>-->
    </van-cell-group>
    <div class="prompt-wrap">
      <div>博思软件党群e家问题咨询请联系文化与品牌建设部——iboss。</div>
      <!-- <div>问题咨询请加QQ群：693266424</div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    data () {
      return {
        loading:false,
        datas:'',
        account:'',
        password:'',
        code:'',
        codeimg:'',
        codeLoading:false,
        work_number:'',
        code:'',
      }
    },
    methods: {
      goEegister: function () {
        this.$router.push({ name: 'Register' })
      },
    // getCode: function () {
    //   var _this = this
    //       var reg = /^[1][3456789][0-9]{9}$/;
    //   if (reg.test(this.mobile)){
    //     this.codeLoading = true
    //     this.$api.post('WebApi/Login/Register/sendMmsCode', {mobile:this.mobile,type:1}, res => {
    //       if(res.data.errCode == '0000'){
    //         console.log("发送验证码",res)
    //         var time = 60
    //         var dd = setInterval(function () {
    //           time--
    //           $(".sendCode .van-button").html(time+' s')
    //           if(time <= 0){
    //             clearInterval(dd)
    //             _this.codeLoading = false
    //             $(".sendCode .van-button").html('<span class=\\"van-button__text\\">重新发送</span>')
    //           }
    //         },1000)
    //         this.$toast("发送成功请注意查收");
    //       }else {
    //         this.$toast(res.data.desc);
    //         _this.codeLoading = false
    //       }
    //     })
    //   }else{
    //     this.$toast("请输入正确的手机号码");
    //     return false;
    //   }
    //   },
      senData: function () {
        var wecha=localStorage.getItem('BLHwechat_info_id');
        // console.log(wecha)
        if (!this.password || !this.work_number) {
          this.$toast('工号或密码不能为空');
          return false
        }
        this.loading = true
        this.$api.post('WebApi/Login/Index/loginByPassword', {password:this.password,work_number:this.work_number}, res => {
          if(res.data.errCode == '0000'){
            localStorage.setItem("BLHuser",res.data.data)
            this.getRead()

          }else{
            this.$toast(res.data.desc);
//            this.getCode()
          }
          this.loading = false
        })
      },
      //验证文章是否已读
      getRead:function () {
        var readid = localStorage.getItem("read_id")||''
        var isUser = localStorage.getItem("BLHuser")
        if(readid!=''){
          this.$api.post('WebApi/Artice/Index/preview', {token:isUser,id:readid}, res => {
            var point=res.data.data.points;
            var readlist=JSON.stringify(res.data.data.articedata);
            if(res.data.errCode == '5020'){
              this.$router.push({name: 'Readed', params: {readlist:readlist,point:point}})
              document.body.removeChild(document.getElementById('Loading'))
            }else{
              if(res.data.errCode == '0000'){
                this.$router.push({name: 'Read', params: {readlist:readlist,point:point}})
                document.body.removeChild(document.getElementById('Loading'))
              }else{
                if(res.data.errCode == '0303'){
                  document.body.removeChild(document.getElementById('Loading'))
                }
              }
            }
          })
        }else{
          this.$router.replace({ path: 'Home' })
          console.log(this.$router)
          document.body.removeChild(document.getElementById('Loading'))
        }
      },
    },
    mounted () {

    },
  }
</script>

<style lang="less" scoped>
  .login{
    width: 100%;
    min-height: 100vh;
    background: #fff;
    /*background-image: url("/static/images/login-bg.png");*/
    /*background-size: 100% 100%;*/
    .van-cell-group{
      padding: 0 20px;
    }
    .login-box{
      padding-top: 7vh;
      padding-bottom: 25%;
      text-align: center;
    }
    .logo{
      width: auto;
      min-width: 120px;
      max-width: 170px;
    }
    .van-button{
      padding: 0;
    }
    .codeimg{
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    .codebox{
      line-height: 35px;
    }
    .codebox .van-button{
      height: 30px;
      line-height: 30px;
      border: none;
    }
    .loginbtn{
      margin-bottom: 15px;
      padding: 0 15px;
      border-radius: 30px;
      background: #101a86 !important;
    }
    .gecode{
      background: rgba(255,255,255,0) !important;
      color: #969696 !important;
      border: 0;
      font-size: 16px;
    }
    .restBox::after{
      border-bottom-width:0;
    }
    .inputlabel{
      vertical-align: middle;
      font-size: 20px;
      margin-right: 15px;
      margin-top: 2px;
    }
    .van-cell__title{
      .iconfont{
        vertical-align: middle;
        font-size: 20px;
        margin-right: 5px;
      }
    }
    .van-field--has-icon{
      border: 1px solid #DBDCDE;
      margin-bottom: 12px;
      background-color: #F5F6FA;
      border-radius: 30px;
    }
    .van-field__button{
      width: 35%;
      float: right;
      height: 46px;
      .van-button{
        width: 100%;
        height: 100%;
      }
    }
  }
  .prompt-wrap {
    width: 100%;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    div {
      color: #b7b8bb;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue